import React from "react";
import ErrorContent from "@/components/errors/ErrorContent/ErrorContent";

const Error404Page: React.FC = () => {
  return (
    <ErrorContent
      statusCode={404}
      title="ページが見つかりません"
      description="申し訳ございませんが、アクセスしようとしたページが見つかりません。
          URLを再確認いただくか、ホームページに戻って再度お試しください。"
    />
  );
};

export default Error404Page;
